import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon"]

  connect() {
    // 监听 Flowbite dropdown 事件
    this.element.addEventListener('click', (event) => {
      const button = event.currentTarget
      const icon = button.querySelector('svg')

      if (icon) {
        // 使用 requestAnimationFrame 确保在 Flowbite 处理后执行
        requestAnimationFrame(() => {
          const dropdownId = button.getAttribute('data-dropdown-toggle') || button.getAttribute('data-collapse-toggle')
          if (dropdownId) {
            const dropdown = document.getElementById(dropdownId)
            if (dropdown) {
              // 检查 dropdown 是否显示
              const isHidden = dropdown.classList.contains('hidden')

              if (isHidden) {
                icon.classList.remove('rotate-180')
              } else {
                icon.classList.add('rotate-180')
              }
            }
          }
        })
      }
    })
  }
}

